import type { PlatformId } from '../models/fundraising-comparison.models';

export interface FundraisingVersusRoute {
  path: string;
  leftPlatformId: PlatformId;
  rightPlatformId: PlatformId;
}

export const FUNDRAISING_VERSUS_ROUTES: readonly FundraisingVersusRoute[] = [
  {
    path: '/compare/big-nest-vs-cheddar-up/',
    leftPlatformId: 'big-nest',
    rightPlatformId: 'cheddar-up',
  },
  {
    path: '/compare/big-nest-vs-boosterthon/',
    leftPlatformId: 'big-nest',
    rightPlatformId: 'mybooster',
  },
  {
    path: '/compare/big-nest-vs-zeffy/',
    leftPlatformId: 'big-nest',
    rightPlatformId: 'zeffy',
  },
];

export function getVersusRouteForCompetitor(
  platformId: PlatformId,
): FundraisingVersusRoute | undefined {
  return FUNDRAISING_VERSUS_ROUTES.find(
    (route) =>
      route.leftPlatformId === 'big-nest' &&
      route.rightPlatformId === platformId,
  );
}

export function getVersusPlatformIdsForPath(
  pathname: string,
): PlatformId[] | undefined {
  const route = FUNDRAISING_VERSUS_ROUTES.find(
    (candidate) => candidate.path === pathname,
  );
  return route ? [route.leftPlatformId, route.rightPlatformId] : undefined;
}
